<template>
  <div>
    <v-card>
      <!-- Title -->
      <v-card-title class="px-5">
        <span class="primary--text">{{ title }}</span>
        <v-icon
          v-if="showCloseBtn"
          class="ml-auto"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <!-- Details -->
      <v-card-text class="px-5" style="min-height: 400px;">
        <patient-search
          v-show="showForm === 'patientList'"
          @selected="patientSelected"
          @view="viewPatientDetails"
          ref="patientListTable"
        ></patient-search>
         <v-form
          ref="caseForm"
          v-model="valid"
          lazy-validation
        >
          <patient-details
            v-show="showForm === 'patientDetails'"
            :patient="patientDetails"
          ></patient-details>
          <patient-information-form
            v-show="showForm === 'patientCaseInformation'"
            ref="patientInformationForm"
            :form="selectedPatient.patientInformation"
          ></patient-information-form>
          <case-information-form
            v-show="showForm === 'patientCaseInformation'"
            ref="caseInformationForm"
          ></case-information-form>
          <family-history-form
            v-show="showForm === 'familyHistory'"
            ref="familyHistoryForm"
          ></family-history-form>
          <health-information-form
            v-show="showForm === 'healthInformation'"
            ref="healthInformationForm"
          ></health-information-form>
          <case-method-form
            v-show="showForm === 'caseMethod'"
            ref="caseMethodForm"
            :form="selectedPatient.caseMethod"
          ></case-method-form>
         </v-form>
         <div v-if="showForm === 'assignCase'" class="d-flex justify-center align-center title font-weight-bold">
           Redirecting to assign case...
         </div>
        <!-- <assign-case
          v-if="showForm === 'assignCase'"
          :info="createdCaseDetails"
        ></assign-case> -->
        <user-not-found-alert
          v-if="!isUserFound"
          :user="patient"
          @submit="userCreated($event)"
        ></user-not-found-alert>
        <!-- <v-btn @click="getTest()">Click</v-btn> -->
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="d-flex justify-center pb-5" v-if="showForm !== 'assignCase'">
        <!-- Prev Button -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="px-6 mx-2"
          v-if="showForm !== 'patientDetails' && showForm !== 'assignCase'"
          :disabled="showForm === 'patientList' || showForm === formArrangement[0]"
          @click="formNavigator('previous')"
        >
          Prev
        </v-btn>

        <!-- Next/Create Button -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="px-6 mx-2"
          v-if="showNextButton"
          :disabled="!haveSelectedPatient"
          @click="getFormData()"
        >
          {{ isLastForm ? "Create" : "Next" }}
        </v-btn>

        <!-- Check if user exists button -->
         <v-btn
          depressed
          rounded
          color="primary"
          class="px-6 mx-2"
          @click="checkUserExist()"
          v-else
          :disabled="!haveSelectedPatient"
        >
          Next
        </v-btn>
        
        <!-- Back Button -->
        <v-btn
          depressed
          rounded
          color="primary"
          class="px-6 mx-2"
          v-if="showForm === 'patientDetails'"
          @click="formNavigator('previous')"
        >
          Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import PmsConstant from "../../js/PmsConstant";
  import moment from "moment";
  import API from '@/api';
  const CasesV2 = API.get('Cases');
  const User = API.get('User');

  export default {
    name: 'CreateCase',

    components: {
      PatientDetails: () => import('./PatientDetails.vue'),
      PatientSearch: () => import('./PatientSearch.vue'),
      // AssignCase: () => import('./AssignCase'),
      PatientInformationForm: () => import("./forms/PatientInformationForm"),
      CaseInformationForm: () => import("./forms/CaseInformationForm"),
      FamilyHistoryForm: () => import("./forms/FamilyHistoryForm"),
      HealthInformationForm: () => import("./forms/HealthInformationForm"),
      UserNotFoundAlert: () => import("./alerts/UserNotFoundAlert"),
      CaseMethodForm: () => import("./forms/CaseMethodForm")
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    props: {
      showCloseBtn: {
        type: Boolean, 
        default: false 
      },
      reset: {
        type: Boolean, 
        default: false 
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    data: () => ({
      formArrangement: [
        "patientCaseInformation",
        "familyHistory",
        "healthInformation",
        "caseMethod"
      ],
      patientDetails: {},
      selectedPatient: {},
      createdCaseDetails: {},
      showForm: "patientList",
      valid: false,
      isUserFound: true //true
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      isLastForm: function() {
        let lastIndex = this.formArrangement.length - 1;
        if (this.showForm === this.formArrangement[lastIndex]) {
          return true;
        }

        return false;
      },

      title: function() {
        if (this.showForm === "patientDetails") {
          return `Patient ID: ${this.patientDetails.PatientId}`
        }

        if (this.showForm === "assignCase") {
          return "";
        }

        return "Create Case from PMS";
      },

      patient() {
        return this.$store.getters['pms/patient']
      },

      haveSelectedPatient() {
        let object = this.selectedPatient;
        return !(object && Object.keys(object).length === 0 && object.constructor === Object);
      },
      
      showNextButton() {
        if (this.showForm === "patientList") {
          return false;
        }

        if (this.showForm === "assignCase") {
          return false;
        }
        // showForm !== 'patientDetails' && showForm !== 'assignCase'
        return this.showForm !== "patientDetails"
          && this.showForm !== "assignCase"
          && this.isUserFound;
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    watch: {
      reset(value) {
        console.log({ value }, "reset");
        if (value) {
          this.resetComponent();
        }
      }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    methods: {
      getTest() {
        console.log({patient: this.patient})
      },
      resetComponent() {
         console.log({
            ref: this.$refs.caseForm,
            valid: this.valid,
            patient: this.patient,
            table: this.$refs.patientListTable
          });

          this.$refs.caseForm.reset();
          this.$store.commit('pms/clearData');
          this.showForm = "patientList";
          // this.selectedPatient = {};
          this.$refs.patientListTable.caseNumber = null;
          this.$refs.patientListTable.selected = [];
      },
      async getFormData() {
        if (this.isLastForm) {
          let valid = this.$refs.caseForm.validate();

          if (valid) {
            let patientInformationForm = this.$refs.patientInformationForm;
            let caseInformationForm = this.$refs.caseInformationForm;
            let familyHistoryForm = this.$refs.familyHistoryForm;
            let healthInformationForm = this.$refs.healthInformationForm;
            let caseMethodForm = this.$refs.caseMethodForm;

            let form = {
              ...patientInformationForm.form,
              ...caseInformationForm.form,
              relatives: familyHistoryForm.relatives,
              ...healthInformationForm.form,
              case: { ...caseMethodForm.form,
                preferred_datetime: `${caseMethodForm.form.date} ${caseMethodForm.form.time}:00`,
                patient_id: this.patient.id,
                health_concern: caseMethodForm.form.healthConcern
              }
            };

            console.log({ form });

            await this.submitCase(form.case);

            this.showForm = "assignCase";
          }
        } else {
          this.formNavigator("next");
        }
      },


      formNavigator(action) {
        let showForm = this.showForm;

        if (showForm === "patientList" && action === "next") {
          this.showForm = this.formArrangement[0];

          return;
        }

        if (showForm === "patientDetails" && action === "previous") {
          this.showForm = "patientList";

          return;
        }

        let index = this.formArrangement.findIndex(item => item === showForm);

        if (index == -1) {
          this.showForm = showForm;

          return;
        }

        if (action === "next") {
          this.showForm = this.formArrangement[index + 1];

          return;
        }

        if (action === "previous") {
          this.showForm = this.formArrangement[index - 1];

          return;
        }
        
      },

      patientSelected(event) {
        if (event) {
          let patient = this.patient;
          console.log({ event, patient });

          patient.birthdate = patient.Birthdate ? this.convertBirthdate(patient.Birthdate) : null;

          patient.height = this.convertHeightToFeet(patient.Height);

          this.selectedPatient = {
            patientInformation: {
              name: patient.FullName,
              height: {
                feet: patient.height ? patient.height.feet : 0,
                inch: patient.height ? patient.height.inch : 0
              },
              weight: patient.Weight || 0,
              company: patient.NameOfCompany,
              age: patient.age,
              provider: patient.ProviderName,
              birthdate: patient.birthdate
            },
            caseMethod: {
              pmsCaseNumber: patient.CaseNumber,
              healthConcern: patient.CaseTitle,
              name: patient.FullName,
              email: patient.Email
            }
          };

          // this.isUserFound = false;
        } else {
          this.selectedPatient = {};
        }
      },

      viewPatientDetails(event) {
        this.patientDetails = { ...event };
        this.patientDetails.Gender = PmsConstant.getGender(this.patientDetails.GenderId).text;
        this.patientDetails.CivilStatus = PmsConstant.getCivilStatus(this.patientDetails.CivilStatus).text;

        this.showForm = "patientDetails";
      },

      submitCase(form) {
        CasesV2.create(form)
        .then(response => {
          console.log({ response }, "submitCase");

          this.createdCaseDetails = {
            case: {
              id: response.data.id
            },
            health_concern: this.patient.CaseTitle,
            case_number: response.data.case_number,
            patient: {
              full_name: this.patient.FullName,
              health_concern: this.patient.CaseTitle,
              case_number: response.data.case_number,
              first_name: this.patient.FirstName,
              last_name: this.patient.LastName,
              email: this.patient.Email
            },
            consultations: response.data.consultations
          };

          this.showForm = "assignCase";

          console.log({ createdCaseDetails: this.createdCaseDetails })

          setTimeout(() => {
            this.$emit('showAssignCaseDialog', response.data);
            this.resetComponent();
          }, 1000);
        })
        .catch(error => {
          console.log({ error });
        });
      },

      convertHeightToFeet(height) {
        let realFeet = ((height*0.393700) / 12);
        let feet = Math.floor(realFeet);
        let inches = Math.round((realFeet - feet) * 12);

        return {
          feet,
          inch: inches
        };
      },

      convertBirthdate(birthdate) {
        return moment(birthdate).format("Y-MM-DD");
      },

      checkUserExist() {
        console.log({patient: this.patient});
        let params = {
          search: this.patient.Email
        };

        console.log({ params });

        User.search({ params })
          .then(async response => {
            console.log({ response })

            if (response.data.data.length) {
              let responsePatient = response.data.data[0];

              // let havePatientDetails = responsePatient.patient;

              console.log({
                // havePatientDetails,
                patientData: this.patient
              });

              // if (!havePatientDetails) {
                let form = {
                  is_patient: 1,
                  full_name: this.patient.FullName,
                  height: this.patient.Height,
                  weight: this.patient.Weight,
                  gender: PmsConstant.getGender(this.patient.GenderId).text || null,
                  marital_status: PmsConstant.getCivilStatus(this.patient.CivilStatus).text || null,
                  birthdate: this.patient.birthdate,
                  mobile_number: this.patient.MobileNumber
                };

                console.log({id: responsePatient.id})

                await User.updateUser(responsePatient.id, form)
                  .then(response => {
                    console.log({ response })
                  })
                  .catch(error => {
                    console.log({ error })
                  });
              // }

              // console.log(responsePatient.patient, "qweqwe");
              // console.log({ patient: this.patient}, "checkUserExist")
              // console.log("exists");

              this.isUserFound = true;
              this.showForm = "patientCaseInformation";
              this.patient.id = responsePatient.id;
            } else {
              this.isUserFound = false;
              console.log("register");
            }
          })
          .catch(error => {
            console.log({ error })
          })
      },
      
       userCreated(event) {
        console.log({ event });
        if (event.success) {
          this.showForm = "patientCaseInformation";
          this.isUserFound = true;

          this.patient.id = event.response.id;

          console.log({ patient: this.patient}, "userCreated")

          return;
        }

        this.showForm = "patientList";
        this.isUserFound = false;

        return;
      }
    }
  }
</script>